import { render, staticRenderFns } from "./MediaCarouselCards.vue?vue&type=template&id=1f48ca5b&"
import script from "./MediaCarouselCards.vue?vue&type=script&lang=js&"
export * from "./MediaCarouselCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports